import { ISharedShiftSlot } from "@src/app/dayView/constants";
import { Shift, UnverifiedShift } from "@src/lib/interface";

export interface ShiftStore {
  showToast: string;
  sharedShiftSlot?: ISharedShiftSlot;
}

export const ActionType = {
  SET_SHOW_TOAST: "SET_SHOW_TOAST",
  UPDATE_SHARED_SHIFT_SLOT: "UPDATE_SHARED_SHIFT_SLOT",
};

interface ShiftActionData extends ShiftStore {
  updatedShift: Shift;
  unverifiedShifts: UnverifiedShift[];
}

export interface ShiftAction {
  type: string;
  data?: Partial<ShiftActionData>;
}
